import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Col, Row, FormGroup, Button, Form } from 'react-bootstrap';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { Label } from '../../components/Label';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { FillPen } from '../../components/Icons';
import _ from 'lodash';
import './style.css';
import AlertMessage from '../../components/Alert';

interface Risco {
    id: string;
    nome: string;
    categoria: any;
}

interface Exame {
    id: string;
    label: string;
}

interface EditingState {
    [key: string]: boolean;
}

interface EditingData {
    [key: string]: {
        adm?: string;
        apos_adm?: string;
        dem?: string;
        ret_tra?: string;
        mud_fun?: string;
        periodicidade_a?: number;
        per_id1?: number;
        periodicidade?: number;
        per_id2?: number;
        periodicidade_d?: number;
    };
}

export function VincularExames() {
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [funcaoSelecionada, setFuncaoSelecionada]: any = useState('');
    const [examesExcluidos, setExamesExcluidos] = useState<{ id_exame: string; id_risco: string }[]>([]);
    const [posAdmissional, setPosAdmissional] = useState('');
    const [selectedExam, setSelectedExam]: any = useState(null);
    const [funcaoCadastrada, setFuncaoCadastrada]: any = useState(null);
    const [data, setData]: any[] = useState([]);
    const [riscoExames, setRiscoExames]: any[] = useState([]);
    const [bancoExames, setBancoExames]: any[] = useState([]);
    const [riscosSelecionados, setRiscosSelecionados]: any = useState([]);
    const [loading, setLoading] = useState(false);
    const [riscoSelecionadoParaExame, setRiscoSelecionadoParaExame]: any = useState(null);
    const [listaDeRiscos, setListaDeRiscos] = useState<Risco[]>([]);
    const [baseExames, setBaseExames] = useState<Exame[]>([]);
    const [examesSelecionados, setExamesSelecionados] = useState<Exame[]>([]);
    const [checkbox, setCheckbox] = useState('');
    const [antes, setAntes] = useState('');
    const [aPartir, setAPartir] = useState('');
    const [periodico, setPeriodico] = useState('');
    const [ate, setAte] = useState('');
    const [depois, setDepois] = useState('');
    const [isEditing, setIsEditing] = useState<EditingState>({});
    const [editingData, setEditingData] = useState<EditingData>({});
    const [tipoExame, setTipoExame] = useState({
        admissional: false,
        demissional: false,
        retornoTrabalho: false,
        mudancaFuncao: false,
    });
    const [selectedExams, setSelectedExams] = useState<string[]>([]);
    const [selectAll, setSelectAll] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedExamsData, setSelectedExamsData] = useState<EditingData[]>([]);

    const debouncedFetchExames = _.debounce(async (nome: string) => {
        if (!nome) return; // Evita buscar se não houver input
        setLoading(true);
        try {
            const response = await api.get(`listar-base-exames/${nome}`);
            setBaseExames(response.data);
        } catch (error) {
            console.error("Erro ao buscar exames:", error);
            setBaseExames([]);
        } finally {
            setLoading(false);
        }
    }, 500); // 500 ms de delay

    useEffect(() => {
        if (funcaoSelecionada) {
            handleListFunctionAndRisk();
            handleSearchSavedFunction();
            handleListRiskAndExam();
        }
    }, [funcaoSelecionada]);

    useEffect(() => {
        if (riscoSelecionadoParaExame) {
            handleListRiskAndExam();
        }
    }, [riscoSelecionadoParaExame]);

    const fetchRiscos = _.debounce(async (inputValue: string) => {
        if (!inputValue) return;
        setLoading(true);
        try {
            const response = await api.get(`/buscar-riscos/${inputValue}`);
            setListaDeRiscos(response.data.map((risco: any) => ({ id: risco.id, nome: risco.nome, categoria: risco.AteBaseRiscosCat.categoria })));
        } catch (error) {
            console.error("Erro ao buscar riscos:", error);
            setListaDeRiscos([]);
        } finally {
            setLoading(false);
        }
    }, 500);

    const handleListFunctionAndRisk = async () => {
        if (funcaoSelecionada) {
            try {
                if (funcaoSelecionada.id) {
                    const response = await api.get(`listar-funcao-risco/${funcaoSelecionada.id}`);
                    setData(response.data);

                    const riscos = response.data.map((risco: { categoria: any; id_risco: any; nome_risco: any; id_funcao: any; }) => ({
                        id_risco: risco.id_risco,
                        nome: risco.nome_risco,
                        id_funcao: risco.id_funcao,
                        categoria: risco.categoria
                    }));

                    setRiscosSelecionados(riscos);
                }
            } catch (error) {
                console.error('Erro ao buscar riscos', error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleListRiskAndExam = async () => {
        try {
            const response = await api.get(`listar-risco-exames/${riscoSelecionadoParaExame.id ? riscoSelecionadoParaExame.id : riscoSelecionadoParaExame.id_risco}`);
            setRiscoExames(response.data);
            setBancoExames(response.data.bancoExame)

            const exames = response.data.exame.map((exame: { id_exame: any; nome_exame: any; }) => ({
                id: exame.id_exame,
                nome: exame.nome_exame,
            }));

            setExamesSelecionados(exames);
        } catch (error) {
            console.error('Erro ao buscar riscos', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearchSavedFunction = async () => {
        if (funcaoSelecionada) {
            try {
                if (funcaoSelecionada.id) {
                    const response = await api.get(`buscar-funcao-cadastrada/${funcaoSelecionada.id}`);
                    setFuncaoCadastrada(response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar riscos', error);
            }
        }
    };

    const handleSaveRiscosExames = async () => {
        if (riscoSelecionadoParaExame == null || selectedExam == null) {
            setAlert({ show: true, message: 'Por favor, selecione um risco e um exame antes de vincular!', variant: 'danger' });
            return;
        }

        const payload = {
            riscos: riscoSelecionadoParaExame,
            exames: selectedExam,
        };

        const formData = {
            id_base_exames: selectedExam ? selectedExam.id : null,
            adm: tipoExame.admissional ? 1 : 0,
            apos_adm: posAdmissional || 0,
            dem: tipoExame.demissional ? 1 : 0,
            ret_tra: tipoExame.retornoTrabalho ? 1 : 0,
            mud_fun: tipoExame.mudancaFuncao ? 1 : 0,
            periodicidade_a: antes || 0,
            per_id1: aPartir || 0,
            periodicidade: periodico || 0,
            per_id2: ate || 0,
            periodicidade_d: depois || 0,
            riscos: riscoSelecionadoParaExame
        };

        try {
            await api.post(`inserir-exame-pcmso`, formData);
            await api.post('vincular-risco-exame', payload);
            setExamesExcluidos([]);
            handleListRiskAndExam();
            setAlert({ show: true, message: 'Risco e exames vinculados com sucesso!', variant: 'success' });
        } catch (error) {
            console.error('Erro ao vincular risco e exames', error);
            setAlert({ show: true, message: 'Erro ao vincular risco e exames. Tente novamente!', variant: 'danger' });
        }
    };

    const handleCheckboxChange = (e: any) => {
        const { name, checked } = e.target;
        setTipoExame(prevTipoExame => ({
            ...prevTipoExame,
            [name]: checked
        }));
    };

    const mesesOpcoes = [
        { label: '3 meses', value: "3" },
        { label: '6 meses', value: "6" },
        { label: '12 meses', value: "12" },
        { label: '24 meses', value: "24" },
        { label: '36 meses', value: "36" },
        { label: '48 meses', value: "48" },
        { label: '60 meses', value: "60" },
    ];

    const idadeOpcoes = [{ label: 'N', value: 0 }, ...Array.from({ length: 84 }, (_, i) => ({ label: `${i + 16}`, value: i + 16 }))];

    const formatarPeriodicidade = (exame: any) => {
        const partes = [];
        const { periodicidade_a, per_id1, periodicidade, per_id2, Periodicidade_d } = exame;

        // Antes
        if (periodicidade_a > 0 && per_id1 > 0) {
            partes.push(`${periodicidade_a} meses até ${per_id1} anos`);
        }

        // Periodicidade entre "a partir" e "até"
        if (periodicidade > 0 && per_id1 > 0 && per_id2 > 0) {
            partes.push(`${periodicidade} meses de ${per_id1} anos até ${per_id2} anos`);
        } else if (periodicidade > 0 && per_id1 === 0 && per_id2 > 0) {
            // Caso especial onde só temos "até"
            partes.push(`${periodicidade} meses até ${per_id2} anos`);
        } else if (periodicidade > 0 && per_id1 > 0 && per_id2 === 0) {
            // Caso especial onde só temos "a partir"
            partes.push(`${periodicidade} meses a partir de ${per_id1} anos`);
        } else if (periodicidade > 0 && per_id1 === 0 && per_id2 === 0) {
            // Caso especial onde só temos periodicidade
            partes.push(`${periodicidade} meses`);
        }

        // Depois
        if (Periodicidade_d > 0 && per_id2 > 0) {
            partes.push(`${Periodicidade_d} meses a partir de ${per_id2} anos`);
        }

        return partes.join(', ');
    };

    const handleDeleteRiskExam = async (exame: any) => {
        try {
            const payload = {
                riscos: riscoSelecionadoParaExame.id ? riscoSelecionadoParaExame.id : riscoSelecionadoParaExame.id_risco,
                exame: exame,
            };

            const response = await api.post('excluir-risco-exames', payload);

            if (response.status == 200) {
                setAlert({ show: true, message: 'Exame excluído com sucesso!', variant: 'success' });
                handleListRiskAndExam();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleEdit = (id: string) => {
        const exame = bancoExames.flat().find((exame: any) => exame.id === id);
        if (exame) {
            setIsEditing((prev) => ({ ...prev, [id]: true }));
            setEditingData((prev) => ({
                ...prev,
                [id]: {
                    id_base_exames: exame.id_base_exames,
                    adm: exame.adm ? "1" : "0",
                    apos_adm: exame.apos_adm ? exame.apos_adm.toString() : "",
                    dem: exame.dem ? "1" : "0",
                    ret_tra: exame.ret_tra ? "1" : "0",
                    mud_fun: exame.mud_fun ? "1" : "0",
                    periodicidade_a: exame.periodicidade_a ? exame.periodicidade_a.toString() : "",
                    per_id1: exame.per_id1 ? exame.per_id1.toString() : "",
                    periodicidade: exame.periodicidade ? exame.periodicidade.toString() : "",
                    per_id2: exame.per_id2 ? exame.per_id2.toString() : "",
                    periodicidade_d: exame.periodicidade_d ? exame.periodicidade_d.toString() : ""
                }
            }));
            setSelectedExamsData((prevData) => {
                const exists = prevData.find((data) => data[id]);
                if (!exists) {
                    return [...prevData, {
                        [id]: {
                            id_base_exames: exame.id_base_exames,
                            adm: exame.adm ? "1" : "0",
                            apos_adm: exame.apos_adm ? exame.apos_adm.toString() : "",
                            dem: exame.dem ? "1" : "0",
                            ret_tra: exame.ret_tra ? "1" : "0",
                            mud_fun: exame.mud_fun ? "1" : "0",
                            periodicidade_a: exame.periodicidade_a ? exame.periodicidade_a.toString() : "",
                            per_id1: exame.per_id1 ? exame.per_id1.toString() : "",
                            periodicidade: exame.periodicidade ? exame.periodicidade.toString() : "",
                            per_id2: exame.per_id2 ? exame.per_id2.toString() : "",
                            periodicidade_d: exame.periodicidade_d ? exame.periodicidade_d.toString() : ""
                        }
                    }];
                }
                return prevData;
            });
        }
    };



    const handleSaveEdit = (id: string) => {
        setEditingData(prev => {
            const updatedData = { ...prev[id] };
            setSelectedExamsData(prevData => {
                return prevData.map(data => {
                    if (data[id]) {
                        return { [id]: updatedData };
                    }
                    return data;
                });
            });
            return { ...prev, [id]: updatedData };
        });
        setIsEditing(prev => ({ ...prev, [id]: false }));
    };



    const handleCancelEdit = (id: string) => {
        setIsEditing((prev: any) => ({ ...prev, [id]: false }));
        setEditingData(prev => ({ ...prev, [id]: {} }));
    };

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        setSelectedExams(selectAll ? [] : bancoExames.flat().map((exame: any) => exame.id));
    };

    const handleSelectExam = (id: string) => {
        const exame = bancoExames.flat().find((exame: any) => exame.id === id);
        if (exame) {
            setSelectedExams((prevSelected) =>
                prevSelected.includes(id) ? prevSelected.filter((examId) => examId !== id) : [...prevSelected, id]
            );

            setSelectedExamsData((prevData: any) => {
                const exists = prevData.find((data: any) => data[id]);
                if (exists) {
                    return prevData.filter((data: any) => !data[id]);
                }
                return [...prevData, {
                    [id]: {
                        id_base_exames: exame.id_base_exames,
                        adm: exame.adm ? "1" : "0",
                        apos_adm: exame.apos_adm ? exame.apos_adm.toString() : "",
                        dem: exame.dem ? "1" : "0",
                        ret_tra: exame.ret_tra ? "1" : "0",
                        mud_fun: exame.mud_fun ? "1" : "0",
                        periodicidade_a: exame.periodicidade_a ? exame.periodicidade_a.toString() : "",
                        per_id1: exame.per_id1 ? exame.per_id1.toString() : "",
                        periodicidade: exame.periodicidade ? exame.periodicidade.toString() : "",
                        per_id2: exame.per_id2 ? exame.per_id2.toString() : "",
                        periodicidade_d: exame.periodicidade_d ? exame.periodicidade_d.toString() : ""
                    }
                }];
            });
        }
    };


    const handleEditSelectedExams = () => {
        setEditMode(true)
        selectedExams.forEach((id) => handleEdit(id));
    };

    const handleDeleteSelectedExams = async () => {
        try {
            const payload = {
                riscos: riscoSelecionadoParaExame.id ? riscoSelecionadoParaExame.id : riscoSelecionadoParaExame.id_risco,
                exame: selectedExams,
            };

            const response = await api.post('excluir-risco-exames', payload);

            setAlert({ show: true, message: 'Exames excluídos com sucesso!', variant: 'success' });
            handleListRiskAndExam();
            setSelectedExams([]);
            setSelectedExamsData([]);

        } catch (error) {
            console.log(error);
            setAlert({ show: true, message: 'Erro ao excluir exames. Tente novamente!', variant: 'danger' });
        }
    };


    const handleSaveAllEdits = async () => {
        try {
            setEditMode(false)
            await Promise.all(selectedExamsData.map(async (data) => {
                const [id] = Object.keys(data);
                await api.post('editar-exames', data[id]);
            }));
            setIsEditing({});
            setEditingData({});
            setSelectedExams([]);
            setSelectedExamsData([]);
            setSelectAll(false);
            handleListRiskAndExam();
            setAlert({ show: true, message: 'Exames editados com sucesso!', variant: 'success' });
        } catch (error) {
            console.error('Erro ao salvar exames', error);
            setAlert({ show: true, message: 'Erro ao salvar exames. Tente novamente!', variant: 'danger' });
        }
    };




    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <CardContent>
                    <Row>
                        <Col md={6}>
                            <FormGroup className='form-group-dsg'>
                                <Label title="RISCOS (DIGITE E SELECIONE)" htmlFor="exa" />
                                <Autocomplete
                                    value={riscoSelecionadoParaExame}
                                    onChange={(event, newValue: any) => {
                                        setRiscoSelecionadoParaExame(newValue);
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        fetchRiscos(newInputValue); // Corrigido para usar fetchRiscos
                                    }}
                                    noOptionsText="Digite e selecione"
                                    style={{ width: '100%', height: '80px', maxHeight: '100px' }}
                                    getOptionLabel={(option) => option ? option.nome + ' - ' + option.categoria : ""}
                                    renderInput={(params) => <TextField {...params} label="" />}
                                    options={listaDeRiscos}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup className='form-group-dsg'>
                                <Label title="EXAME (DIGITE E SELECIONE)" htmlFor="exa" />
                                <Autocomplete
                                    key={selectedExam ? selectedExam.id : 'empty'}
                                    value={selectedExam}
                                    noOptionsText="Digite e selecione"
                                    style={{ width: '100%', height: '40px' }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label=""
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                    options={baseExames.map((exame: any) => ({ label: exame.nome, id: exame.id }))}
                                    getOptionLabel={(option) => option.label}
                                    getOptionDisabled={(option) => bancoExames.flat().some((b: any) => b.ateBaseExames.id === option.id)}
                                    onChange={(event, newValue) => {
                                        setSelectedExam(newValue);
                                    }}
                                    onInputChange={(event, newValue) => {
                                        debouncedFetchExames(newValue);
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col style={{ marginBottom: '10px' }} className='nameInput'>
                            <Col>
                                <input
                                    key={checkbox}
                                    type="checkbox"
                                    name="admissional"
                                    onChange={handleCheckboxChange}
                                    checked={tipoExame.admissional}
                                    style={{ marginRight: '10px' }}
                                />
                                <Label title="Admissional" htmlFor="posAdm" />

                            </Col>
                            <Col>

                                <input
                                    key={checkbox}
                                    type="checkbox"
                                    name="demissional"
                                    onChange={handleCheckboxChange}
                                    checked={tipoExame.demissional}
                                    style={{ marginRight: '10px' }}
                                />
                                <Label title="Demissional" htmlFor="posAdm" />
                            </Col>

                            <Col>

                                <input
                                    key={checkbox}
                                    type="checkbox"
                                    name="retornoTrabalho"
                                    onChange={handleCheckboxChange}
                                    checked={tipoExame.retornoTrabalho}
                                    style={{ marginRight: '10px' }}
                                />
                                <Label title="Retorno ao Trabalho" htmlFor="posAdm" />
                            </Col>
                            <Col>

                                <input
                                    key={checkbox}
                                    type="checkbox"
                                    name="mudancaFuncao"
                                    onChange={handleCheckboxChange}
                                    checked={tipoExame.mudancaFuncao}
                                    style={{ marginRight: '10px' }}
                                />
                                <Label title="Mudança de Risco Ocupacional" htmlFor="posAdm" />
                            </Col>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={4}>
                            <FormGroup>
                                <Label title="Pós Admissional" htmlFor="posAdm" />
                                <Form.Select id="posAdm" value={posAdmissional} onChange={(e) => setPosAdmissional(e.target.value)}>
                                    <option value="">Selecione</option>
                                    <option value="3">3 meses</option>
                                    <option value="6">6 meses</option>
                                </Form.Select>

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        {(aPartir && ate) && (
                            <Col md={2}>
                                <FormGroup>
                                    <Label title="Antes" htmlFor="antes" />
                                    <Form.Select id="antes" value={antes} onChange={(e) => setAntes(e.target.value)}>
                                        <option value="">Selecione</option>
                                        {mesesOpcoes.map((opcao) => (
                                            <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                        ))}
                                    </Form.Select>
                                </FormGroup>
                            </Col>
                        )}
                        {periodico && (
                            <Col md={2}>
                                <FormGroup>
                                    <Label title="A partir" htmlFor="aPartir" />
                                    <Form.Select id="aPartir" value={aPartir} onChange={(e) => setAPartir(e.target.value)}>
                                        <option value="">Selecione</option>
                                        {idadeOpcoes.map((opcao) => (
                                            <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                        ))}
                                    </Form.Select>
                                </FormGroup>
                            </Col>
                        )}
                        <Col md={2}>
                            <FormGroup>
                                <Label title="Periódico" htmlFor="periodico" />
                                <Form.Select id="periodico" value={periodico} onChange={(e) => {
                                    setPeriodico(e.target.value);
                                }}>
                                    <option value="">Selecione</option>
                                    {mesesOpcoes.map((opcao) => (
                                        <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                    ))}
                                </Form.Select>
                            </FormGroup>
                        </Col>

                        {periodico && (
                            <Col md={2}>
                                <FormGroup>
                                    <Label title="Até" htmlFor="ate" />
                                    <Form.Select id="ate" value={ate} onChange={(e) => setAte(e.target.value)}>
                                        <option value="">Selecione</option>
                                        {idadeOpcoes.map((opcao) => (
                                            <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                        ))}
                                    </Form.Select>
                                </FormGroup>
                            </Col>
                        )}

                        {(aPartir && ate) && (
                            <Col md={2}>
                                <FormGroup>
                                    <Label title="Depois" htmlFor="depois" />
                                    <Form.Select id="depois" value={depois} onChange={(e) => setDepois(e.target.value)}>
                                        <option value="">Selecione</option>
                                        {mesesOpcoes.map((opcao) => (
                                            <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                        ))}
                                    </Form.Select>
                                </FormGroup>
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col md={1} style={{ marginBottom: '20px' }}>
                            <Button className='btn-success' type="submit" style={{ marginTop: '10px' }} onClick={handleSaveRiscosExames}>
                                Inserir
                            </Button>
                        </Col>
                    </Row>
                    <div style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid #007bff', marginTop: '30px' }}>
                        <div style={{ maxHeight: '250px', overflow: 'auto' }}>
                            <table
                                style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                }}
                            >
                                <thead
                                    style={{
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                    }}
                                >
                                    <tr>
                                        <th style={{ borderRight: '1px solid white', padding: '15px 20px', fontSize: '13px', fontWeight: 'normal', textAlign: 'center' }}>Nome</th>
                                        <th style={{ borderRight: '1px solid white', padding: '15px 20px', fontSize: '13px', fontWeight: 'normal', textAlign: 'center' }}>Adm.</th>
                                        <th style={{ borderRight: '1px solid white', padding: '15px 20px', fontSize: '13px', fontWeight: 'normal', textAlign: 'center' }}>Após Adm.</th>
                                        <th style={{ borderRight: '1px solid white', padding: '15px 20px', fontSize: '13px', fontWeight: 'normal', textAlign: 'center' }}>Dem.</th>
                                        <th style={{ borderRight: '1px solid white', padding: '15px 20px', fontSize: '13px', fontWeight: 'normal', textAlign: 'center' }}>Ret. Tra.</th>
                                        <th style={{ borderRight: '1px solid white', padding: '15px 20px', fontSize: '13px', fontWeight: 'normal', textAlign: 'center' }}>Mud. Fun.</th>
                                        <th style={{ borderRight: '1px solid white', padding: '15px 20px', fontSize: '13px', fontWeight: 'normal', textAlign: 'center' }}>Periódico</th>
                                        <th style={{ padding: '15px 20px', textAlign: 'center' }}>
                                            <input
                                                type="checkbox"
                                                onChange={handleSelectAll}
                                                checked={selectAll}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(bancoExames) && bancoExames.length > 0 ? (
                                        bancoExames.flat().map((exame, index) => (
                                            <tr key={index}>
                                                <td style={{ borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', padding: '15px 20px', fontSize: '13px', textAlign: 'center' }}>
                                                    {exame.ateBaseExames.nome}
                                                </td>
                                                <td style={{ borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', padding: '15px 20px', fontSize: '13px', textAlign: 'center' }}>
                                                    {isEditing[exame.id] ? (
                                                        <select
                                                            style={{ width: '100%', padding: 0 }}
                                                            value={editingData[exame.id]?.adm ?? exame.adm}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEditingData((prev) => ({
                                                                    ...prev,
                                                                    [exame.id]: { ...prev[exame.id], adm: value },
                                                                }));
                                                                setSelectedExamsData((prevData) => {
                                                                    return prevData.map((data) => {
                                                                        if (data[exame.id]) {
                                                                            return { [exame.id]: { ...data[exame.id], adm: value } };
                                                                        }
                                                                        return data;
                                                                    });
                                                                });
                                                            }}
                                                        >
                                                            <option value="1">Sim</option>
                                                            <option value="0">Não</option>
                                                        </select>
                                                    ) : (
                                                        exame.adm ? 'Sim' : '-'
                                                    )}
                                                </td>
                                                <td style={{ borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', padding: '15px 20px', fontSize: '13px', textAlign: 'center' }}>
                                                    {isEditing[exame.id] ? (
                                                        <select
                                                            style={{ width: '100%', padding: 0 }}
                                                            value={editingData[exame.id]?.apos_adm ?? exame.apos_adm}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEditingData((prev) => ({
                                                                    ...prev,
                                                                    [exame.id]: { ...prev[exame.id], apos_adm: value },
                                                                }));
                                                                setSelectedExamsData((prevData) => {
                                                                    return prevData.map((data) => {
                                                                        if (data[exame.id]) {
                                                                            return { [exame.id]: { ...data[exame.id], apos_adm: value } };
                                                                        }
                                                                        return data;
                                                                    });
                                                                });
                                                            }}
                                                        >
                                                            <option value="">Selecione</option>
                                                            <option value="3">3 meses</option>
                                                            <option value="6">6 meses</option>
                                                        </select>
                                                    ) : (
                                                        exame.apos_adm ? `${exame.apos_adm} meses` : '-'
                                                    )}
                                                </td>
                                                <td style={{ borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', padding: '15px 20px', fontSize: '13px', textAlign: 'center' }}>
                                                    {isEditing[exame.id] ? (
                                                        <select
                                                            style={{ width: '100%', padding: 0 }}
                                                            value={editingData[exame.id]?.dem ?? exame.dem}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEditingData((prev) => ({
                                                                    ...prev,
                                                                    [exame.id]: { ...prev[exame.id], dem: value },
                                                                }));
                                                                setSelectedExamsData((prevData) => {
                                                                    return prevData.map((data) => {
                                                                        if (data[exame.id]) {
                                                                            return { [exame.id]: { ...data[exame.id], dem: value } };
                                                                        }
                                                                        return data;
                                                                    });
                                                                });
                                                            }}
                                                        >
                                                            <option value="1">Sim</option>
                                                            <option value="0">Não</option>
                                                        </select>
                                                    ) : (
                                                        exame.dem ? 'Sim' : '-'
                                                    )}
                                                </td>
                                                <td style={{ borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', padding: '15px 20px', fontSize: '13px', textAlign: 'center' }}>
                                                    {isEditing[exame.id] ? (
                                                        <select
                                                            style={{ width: '100%', padding: 0 }}
                                                            value={editingData[exame.id]?.ret_tra ?? exame.ret_tra}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEditingData((prev) => ({
                                                                    ...prev,
                                                                    [exame.id]: { ...prev[exame.id], ret_tra: value },
                                                                }));
                                                                setSelectedExamsData((prevData) => {
                                                                    return prevData.map((data) => {
                                                                        if (data[exame.id]) {
                                                                            return { [exame.id]: { ...data[exame.id], ret_tra: value } };
                                                                        }
                                                                        return data;
                                                                    });
                                                                });
                                                            }}
                                                        >
                                                            <option value="1">Sim</option>
                                                            <option value="0">Não</option>
                                                        </select>
                                                    ) : (
                                                        exame.ret_tra ? 'Sim' : '-'
                                                    )}
                                                </td>
                                                <td style={{ borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', padding: '15px 20px', fontSize: '13px', textAlign: 'center' }}>
                                                    {isEditing[exame.id] ? (
                                                        <select
                                                            style={{ width: '100%', padding: 0 }}
                                                            value={editingData[exame.id]?.mud_fun ?? exame.mud_fun}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEditingData((prev) => ({
                                                                    ...prev,
                                                                    [exame.id]: { ...prev[exame.id], mud_fun: value },
                                                                }));
                                                                setSelectedExamsData((prevData) => {
                                                                    return prevData.map((data) => {
                                                                        if (data[exame.id]) {
                                                                            return { [exame.id]: { ...data[exame.id], mud_fun: value } };
                                                                        }
                                                                        return data;
                                                                    });
                                                                });
                                                            }}
                                                        >
                                                            <option value="1">Sim</option>
                                                            <option value="0">Não</option>
                                                        </select>
                                                    ) : (
                                                        exame.mud_fun ? 'Sim' : '-'
                                                    )}
                                                </td>
                                                <td style={{ borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', padding: '15px 20px', fontSize: '13px', textAlign: 'center' }}>
                                                    {isEditing[exame.id] ? (
                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                            <select
                                                                style={{ width: '100%', padding: 0 }}
                                                                value={editingData[exame.id]?.periodicidade_a ?? exame.periodicidade_a}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    setEditingData((prev) => ({
                                                                        ...prev,
                                                                        [exame.id]: { ...prev[exame.id], periodicidade_a: value },
                                                                    }));
                                                                    setSelectedExamsData((prevData: any) => {
                                                                        return prevData.map((data: any) => {
                                                                            if (data[exame.id]) {
                                                                                return { [exame.id]: { ...data[exame.id], periodicidade_a: value } };
                                                                            }
                                                                            return data;
                                                                        });
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Selecione</option>
                                                                <option value="1">1 mês</option>
                                                                <option value="2">2 meses</option>
                                                            </select>
                                                            <select
                                                                style={{ width: '100%', padding: 0 }}
                                                                value={editingData[exame.id]?.per_id1 ?? exame.per_id1}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    setEditingData((prev) => ({
                                                                        ...prev,
                                                                        [exame.id]: { ...prev[exame.id], per_id1: value },
                                                                    }));
                                                                    setSelectedExamsData((prevData: any) => {
                                                                        return prevData.map((data: any) => {
                                                                            if (data[exame.id]) {
                                                                                return { [exame.id]: { ...data[exame.id], per_id1: value } };
                                                                            }
                                                                            return data;
                                                                        });
                                                                    });
                                                                }}
                                                            >
                                                                <option value="1">Ano</option>
                                                                <option value="2">Mês</option>
                                                            </select>
                                                        </div>
                                                    ) : (
                                                        formatarPeriodicidade(exame)
                                                    )}
                                                </td>
                                                <td style={{ padding: '15px 20px', borderTop: '1px solid lightgray', fontSize: '13px', textAlign: 'center' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedExams.includes(exame.id)}
                                                        onChange={() => handleSelectExam(exame.id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={8} style={{ padding: '15px 20px', fontSize: '13px', textAlign: 'center' }}>
                                                Nenhum exame encontrado.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {selectedExams.length > 0 && (
                        <>

                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                                {!editMode ? (
                                    <Button className='btn btn-outline-primary btn-outline-main' onClick={handleEditSelectedExams}>
                                        Editar Selecionados
                                    </Button>
                                ) : (
                                    <Button
                                        className='btn btn-success'
                                        style={{ marginLeft: '10px' }}
                                        onClick={handleSaveAllEdits}
                                    >
                                        Salvar Edições
                                    </Button>
                                )}
                                <Button
                                    style={{ marginLeft: '10px', backgroundColor: 'gray', color: 'white', borderColor: 'gray' }}
                                    onClick={() => {
                                        setSelectedExams([]);
                                        setIsEditing({});
                                        setEditMode(false);
                                        setSelectedExamsData([]);
                                        setSelectAll(false)
                                    }}
                                >
                                    Cancelar
                                </Button>
                                {!editMode && (
                                    <Button
                                        style={{ marginLeft: '10px', backgroundColor: 'red', color: 'white', borderColor: 'red' }}
                                        onClick={handleDeleteSelectedExams}
                                    >
                                        Excluir Selecionados
                                    </Button>
                                )}
                            </div>
                        </>
                    )}



                </CardContent>
                <AlertMessage
                    show={alert.show}
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert({ ...alert, show: false })}
                />
            </Main>
        </div>

    );
}